import { Icons } from "assets";
import classNames from "classnames";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NavItem from "shared/components/common/dashboardSideCanvas/navItem";
import { homeSideBarConstants } from "shared/utils/constants";
import styles from "./style.module.scss";

interface SideCanvasProps {
  setIsOpen: (val: boolean) => void;
  isOpen: boolean;
}

const SideCanvas = ({ isOpen, setIsOpen }: SideCanvasProps) => {
  const location = useLocation();

  function handleClick(e: any) {
    const elem: any = document.getElementById("sideCanvas");
    if (!elem.contains(e.target)) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    let elem: any = document.getElementById("backDropContainer");
    elem.addEventListener("click", (event: any) => {
      handleClick(event);
    });
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <div
      className={classNames(styles.backDropContainer, "md:hidden")}
      style={isOpen ? { visibility: "visible" } : { visibility: "hidden" }}
      id="backDropContainer"
    >
      <div
        className={classNames(
          styles.mainContainer,
          isOpen ? styles.shown : styles.hidden
        )}
        id="sideCanvas"
      >
        <div
          className={classNames(
            "flex justify-between items-center px-4 gap-4",
            styles.logoContainer
          )}
        >
          <Icons.Logo />
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => {
              setIsOpen(false);
            }}
          >
            <Icons.Cross />
          </div>
        </div>

        <div className="flex flex-col gap-4 mt-7">
          {homeSideBarConstants?.map((item, index) => {
            let { title, path } = item;
            return (
              <NavItem
                title={title}
                path={path}
                setIsOpen={setIsOpen}
                key={index}
                isBlank
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SideCanvas;
